module.exports = __webpack_public_path__ + "images/172588f00700bb8c4ed1a0312b874517.svg";